import { render, staticRenderFns } from "./VipCustomer.vue?vue&type=template&id=ac4e8fee"
import script from "./VipCustomer.vue?vue&type=script&lang=js"
export * from "./VipCustomer.vue?vue&type=script&lang=js"
import style0 from "./VipCustomer.vue?vue&type=style&index=0&id=ac4e8fee&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports